<div class="p-d-flex">
    <div style="width: 30%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;">
        <div style=" border-right: 1px solid #dee2e6; height: 100%;">
            <div class="header">
                <div class="sidebar_search p-fluid">
                    <div class="p-d-flex p-ai-center p-mr-2">
                        <p-checkbox *ngIf="!filterToggle" [(ngModel)]="selectAll" [binary]="true" inputId="binary"
                            (onChange)="selectOrDeselectAll($event)"></p-checkbox>

                        <p-checkbox *ngIf="filterToggle" [(ngModel)]="businessTypeSelectAll" [binary]="true"
                            inputId="binary" (onChange)="businessTypeSelectOrDeselectAll($event)"></p-checkbox>
                    </div>
                    <div class="p-d-flex">
                        <div *ngIf="broadcastLoading" class="progressLayout">
                            <div class="progressContainer">
                                <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="3">
                                </p-progressSpinner>
                            </div>
                        </div>
                        <span class="p-input-icon-right ">
                            <i *ngIf="searchText !== ''" class="pi pi-times" style="cursor: pointer;"
                                (click)="searchText=''"></i>
                            <input *ngIf="!filterToggle" #searchInput pInputText type="text" [(ngModel)]="searchText"
                                placeholder="Search client" />

                            <input *ngIf="filterToggle" #searchInput pInputText type="text" [(ngModel)]="searchText"
                                placeholder="Search business type" />
                        </span>
                        <div>
                            <button *ngIf="!filterToggle" pButton pRipple type="button" icon="pi pi-search"
                                [style]="{width:'2.1rem',height:'2.1rem'}"
                                class="p-button-rounded p-button-raised p-button-sm p-ml-2"></button>

                            <button *ngIf="!filterToggle" pButton pRipple type="button" icon="pi pi-filter"
                                [style]="{width:'2.1rem',height:'2.1rem'}"
                                class="p-button-rounded p-button-raised p-button-sm p-ml-2"
                                (click)="handleFilter()"></button>

                            <button *ngIf="filterToggle" pButton pRipple type="button" icon="pi pi-check"
                                [style]="{width:'2.1rem',height:'2.1rem'}"
                                class="p-button-rounded p-button-raised p-button-sm p-ml-2 p-button-success"
                                (click)="filterClientByBusinessType()"></button>

                            <button *ngIf="filterToggle" pButton pRipple type="button" icon="pi pi-times"
                                [style]="{width:'2.1rem',height:'2.1rem'}"
                                class="p-button-rounded p-button-raised p-button-sm p-ml-2 p-button-danger"
                                (click)="cancelFilter()"></button>
                        </div>
                    </div>
                </div>
            </div>
            <p-scrollPanel [style]="{width: '100%', height: '385px'}" #sc>
                <!-- <button pButton pRipple type="button" icon="pi pi-plus" title="Add Column" (click)="addColumn()"
                    [disabled]="columns.length === 20" class="p-mr-2"></button>
                <button pButton pRipple type="button" icon="pi pi-minus" title="Remove Column" (click)="removeColumn()"
                    [disabled]="columns.length === 1"></button> -->

                <ul class="sidebar_ul" *ngIf="!filterToggle">
                    <li class="list_sidebar" *ngFor="let client of clients | filter: searchText">
                        <a class="sidebar_container" (click)="addToBroadcastList(client)">
                            <img src="assets/images/chatstasy_circle.png" class="sidebar_profile_img"
                                style="width: 32px;height: 32px;" alt="">
                            <!-- <p-avatar *ngIf="client.userType != 'chatstasy'" class="sidebar_profile_img" label="SMS"
                            shape="circle">
                        </p-avatar> -->
                            <!-- [label]="client.firstName!.charAt(0)+ client.lastName!.charAt(0)" -->
                            <div class="sidebar_info">
                                <div class="sidebar_info_title">
                                    {{client.name}}</div>
                            </div>
                        </a>
                    </li>
                    <p-messages *ngIf="clients?.length == 0 && !isLoading" key="errMsg" class="alignCenter">
                        <ng-template pTemplate>
                            <i class="pi pi-copy" style="font-size: 2rem"></i>
                            <div class="p-ml-2">NO CLIENTS FOUND</div>
                        </ng-template>
                    </p-messages>
                </ul>

                <ul class="sidebar_ul" *ngIf="filterToggle">
                    <li class="list_sidebar" *ngFor="let type of filteredBusinessTypes">
                        <a class="sidebar_container">
                            <div class="sidebar_info">
                                <p-checkbox name="groupname" value="{{type.id}}" [(ngModel)]="selectedBusinessTypes"
                                    label="{{type.name}}"></p-checkbox>
                            </div>
                        </a>
                    </li>
                    <p-messages *ngIf="businessTypes?.length == 0 && !isLoading" key="errMsg" class="alignCenter">
                        <ng-template pTemplate>
                            <i class="pi pi-copy" style="font-size: 2rem"></i>
                            <div class="p-ml-2">NO BUSINESS TYPES FOUND</div>
                        </ng-template>
                    </p-messages>
                </ul>
            </p-scrollPanel>
        </div>
    </div>
    <div style="width: 70%;">
        <div style="width: 100%;">
            <div class="header p-d-flex p-jc-between p-ai-center">
                <span style="font-size: 13px; color: #777;">{{ showLogsPanel ? 'Broadcast Message Log' : 'Recipients' }}</span>
                <button *ngIf="showLogsPanel" pButton pRipple type="button" label="New Broadcast Message"
                    icon="pi pi-plus" class="p-button-text p-button-sm" (click)="startNewBroadcast()"></button>
                <button *ngIf="!showLogsPanel" pButton pRipple type="button" label="Back to Log"
                    icon="pi pi-arrow-left" class="p-button-text p-button-sm" (click)="backToLogs()"></button>
            </div>

            <p-scrollPanel *ngIf="!showLogsPanel" [style]="{width: '100%', height: '387px'}" #sc>
                <div>
                    <div class="p-grid p-m-2">
                        <div style="padding: 1px;" *ngFor="let broad of broadcastList; let i=index"
                            [@animation]="'visible'">
                            <p-chip [label]="broad.name" image="assets/images/chatstasy_circle.png" [removable]="true"
                                (onRemove)="removeToBroadcastList(broad)">
                            </p-chip>
                        </div>
                    </div>
                </div>
                <div *ngIf="isLoading" class="progressLayout">
                    <div class="progressContainer">
                        <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="3">
                        </p-progressSpinner>
                    </div>
                </div>
            </p-scrollPanel>

            <p-scrollPanel *ngIf="showLogsPanel" [style]="{width: '100%', height: '387px'}" #logSc>
                <div class="log-list">
                    <div class="log-item" *ngFor="let log of broadcastLogs" (click)="showLogDetails(log)">
                        <div class="log-item-top">
                            <span class="log-item-time">{{ log.timestamp | date:'short' }}</span>
                            <span class="log-item-attachments" *ngIf="log.attachments?.length">
                                <i class="pi pi-paperclip"></i> {{ log.attachments.length }}
                            </span>
                        </div>
                        <div class="log-item-preview">{{ getTrimmedMessage(log.message) }}</div>
                        <div class="log-item-recipients">To {{ log.recipients?.length || 0 }} business(es)</div>
                    </div>
                    <p-messages *ngIf="broadcastLogs?.length == 0" key="errMsg" class="alignCenter">
                        <ng-template pTemplate>
                            <i class="pi pi-copy" style="font-size: 2rem"></i>
                            <div class="p-ml-2">NO BROADCASTS SENT YET</div>
                        </ng-template>
                    </p-messages>
                </div>
            </p-scrollPanel>

            <div class="footer p-p-2" *ngIf="!showLogsPanel">
                <p-messages key="errMsg" [style]="{
                    'font-size': '12px'
                  }"></p-messages>
                <p-progressBar *ngIf="isLoading && selectedFiles.length" [value]="percentage" [style]="{'height': '6px'}"></p-progressBar>
                <div class="p-d-flex p-ai-center" style="gap: 8px; padding: 0 8px;">
                    <input type="file" accept="*" (change)="selectFile($event)" style="display: none;" #file multiple>
                    <div class="p-d-flex p-ai-center" style="flex-shrink: 0;">
                        <button pButton pRipple type="button" icon="pi pi-paperclip"
                            class="p-button-rounded p-button-text p-button-sm" style="font-size: 1.2rem"
                            (click)="file.click()"></button>
                        <i class="pi pi-bars" style="font-size: 1rem; padding: 0.4375rem 0.25rem; cursor: pointer;"
                            (click)="showToolBar()"></i>
                        <div *ngIf="selectedFiles.length != 0" class="p-d-flex p-ai-baseline">
                            <button pButton pRipple type="button" icon="pi pi-times"
                                class="p-button-rounded p-button-text p-button-sm" style="font-size: 1.2rem"
                                (click)="clearFiles()"></button>
                        </div>
                    </div>
                    <div class="p-d-flex p-ai-center" style="flex: 1; gap: 8px;">
                        <div id="chatArea" style="flex: 1;">
                            <textarea id="broadcastEditor" name="broadcastEditor"
                                style="width: 100%; min-height: 80px; resize: vertical;"></textarea>
                        </div>
                        <button pButton pRipple type="button" label="Send" class="p-button-raised"
                            style="font-size: 12px; flex-shrink: 0;" (click)="prepareMessageBeforeSending()"
                            [disabled]="disabled">
                        </button>
                    </div>
                </div>

                <div class="p-grid p-mt-2 p-ml-2 p-mr-2" *ngIf="selectedFiles.length">
                    <div style="padding: 1px;" *ngFor="let file of selectedFiles; let i=index" [@animation]="'visible'">
                        <p-chip [label]="file.name" [image]="file.type=='image/jpeg' || file.type=='image/png'?file.src:''"
                            [icon]="file.type!='image/jpeg' && file.type!='image/png'? 'pi pi-file':''"
                            [removable]="true" (onRemove)="removeToFileList(file)">
                        </p-chip>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<p-dialog [(visible)]="showLogDetail" [modal]="true" [baseZIndex]="20000" [draggable]="false" [closable]="false"
    [style]="{width: '600px'}">
    <ng-template pTemplate="header">
        <div class="p-d-flex p-jc-between p-ai-center" style="width: 100%;">
            <span>Broadcast Details</span>
            <button pButton pRipple type="button" icon="pi pi-times" class="p-button-rounded p-button-text p-button-sm"
                (click)="closeLogDetail()"></button>
        </div>
    </ng-template>
    <div *ngIf="selectedLog">
        <div style="font-size: 12px; color: #777; margin-bottom: 8px;">
            {{ selectedLog.timestamp | date:'medium' }} &middot; sent by {{ selectedLog.sentByName }}
        </div>
        <div class="ckeditor-content" [innerHTML]="selectedLog.sanitizedMessage"></div>
        <div class="log-detail-section" *ngIf="selectedLog.attachments?.length">
            <div class="log-detail-section-title">Attachments</div>
            <div *ngFor="let a of selectedLog.attachments">
                <a [href]="a.url" target="_blank"><i class="pi pi-paperclip"></i> {{ a.name }}</a>
            </div>
        </div>
        <div class="log-detail-section" *ngIf="selectedLog.recipients?.length">
            <div class="log-detail-section-title">Sent to ({{ selectedLog.recipients.length }})</div>
            <div class="log-recipients-list">
                <span class="log-recipient-tag" *ngFor="let r of selectedLog.recipients">{{ r.businessName }}</span>
            </div>
        </div>
    </div>
</p-dialog>